import { InHomeUtils } from "../../../util/inhomeUtils";

export const checkIfMidnite = lqState => {
    const queryParam = window?.location?.search || '';
    const flagEnabled = lqState && lqState?.runtimeKey && lqState?.runtimeKey?.enableMidnite && lqState?.runtimeKey?.enableMidnite.toUpperCase() === 'Y';
    return flagEnabled || queryParam?.includes('MN=Y') || true;
};

export const checkIfECMidnite = lqState => {
    const queryParam = window?.location?.search || '';
    const flagEnabled = lqState && lqState?.runtimeKey && lqState?.runtimeKey?.ECenableMidnite && lqState?.runtimeKey?.ECenableMidnite.toUpperCase() === 'Y';
    /* Updating query param to true by default as EC MN is enabled 100%
    Adding to fix the minor flickering issue of seeing old screens in EC and supp
    */
    return flagEnabled || queryParam?.includes('ECMN=Y') ;
};

export const checkIfCloudModal = lqState => {
    const queryParam = window?.location?.search || '';
    const flagEnabled = lqState && lqState?.runtimeKey && lqState?.runtimeKey?.cloudDowngradeModal && lqState?.runtimeKey?.cloudDowngradeModal.toUpperCase() === 'Y';
    /* Updating query param to true by default as EC MN is enabled 100%
    Adding to fix the minor flickering issue of seeing old screens in EC and supp
    */
    // return flagEnabled || queryParam?.includes('cloudModal=Y') ;
    return queryParam?.includes('cloudModal=Y') ;
};

export const fiosFiveChnPicker = (lqState, product, buildProduct) => {
    if (lqState.doFlowDetails.isDoFlow && lqState.doFlowDetails.DOIDValue === "FCP") {
        let isFiosFiveTileProd = product && (product.prodTypeVal === 'Fios_Five' || product.prodTypeValue === 'Fios_Five');
        let isFiosFiveSelectedProd = buildProduct.tv.selectedProduct && (buildProduct.tv.selectedProduct.prodTypeVal === 'Fios_Five' || buildProduct.tv.selectedProduct.prodTypeValue === 'Fios_Five');
        if (isFiosFiveTileProd && isFiosFiveSelectedProd && buildProduct.tv.fiosFiveSelectedChannels && !buildProduct.tv.fiosFiveSelectedChannels.length) {
            console.log("++YOUR FIOS TV SELECTED - show channel picker", lqState.doFlowDetails.isDoFlow);
            let channelPickerLinkEl = document.getElementById('FIOSFIVE_MANAGE');
            InHomeUtils.isNotNull(channelPickerLinkEl) && channelPickerLinkEl.click();
        }
    }
};

export const checkIfReqiestTnEnabled = lqState => {
    const queryParamString = new URLSearchParams(window.location.search);
    // fix logic here to loop inside loop for checking query params and aem flags. below logic wont work
    let allowTnReq = true;
    let requestTnAemEnabled = true;
    if (queryParamString && queryParamString.get('enableTnReq') === 'N'){
        console.log('enableTnReq query params1',queryParamString);
        console.log('enableTnReq allowTnReq1',allowTnReq);
        allowTnReq = false;
    }
    else if (queryParamString && queryParamString.get('enableTnReq') === 'Y'){
        console.log('enableTnReq query params2',queryParamString);
        console.log('enableTnReq allowTnReq2',allowTnReq);
        allowTnReq = true;
    }
    else{
        console.log('enableTnReq query params2',queryParamString);
        console.log('enableTnReq allowTnReq2',allowTnReq);
        if(lqState?.runtimeKey?.EnableTnReq?.toUpperCase() === 'N'){
            requestTnAemEnabled = false;
        }
    }
    console.log('enableTnReq requestTnAemEnabled',requestTnAemEnabled);
    console.log('enableTnReq allowTnReq',requestTnAemEnabled);
    return requestTnAemEnabled && allowTnReq;
};

export const checkIfResumeCartLogEnabled = lqState => {
    const queryParamString = window?.location?.search || '';
    let resumeCartQueryParamsEnabled = false;
    resumeCartQueryParamsEnabled = queryParamString?.includes('resumeCartLog=Y')?false:queryParamString?.includes('resumeCartLog=N')?true:false; 
    let resumeCartLogEnabled = false;
    if(lqState?.runtimeKey?.enableResumeCartLog?.toUpperCase() === 'N'){
        resumeCartLogEnabled = false
    }else if (lqState?.runtimeKey?.enableResumeCartLog?.toUpperCase() === 'Y'){
        resumeCartLogEnabled = true
    }
    return resumeCartLogEnabled || resumeCartQueryParamsEnabled;
};  

export const getResumeCartDelay = lqState => {
    const queryParamString = window?.location?.search || '';
    let resumeCartDelay = 500;
    if(lqState && lqState?.runtimeKey && lqState?.runtimeKey?.ResumeCartDelay){
        resumeCartDelay = lqState?.runtimeKey?.ResumeCartDelay
    }
    if(queryParamString?.includes('resumeCartDelay=')){
        const params = new Proxy(new URLSearchParams(queryParamString), {
            get: (searchParams, prop) => searchParams?.get(prop),
          });
        resumeCartDelay = params?.resumeCartDelay;
    }
    return resumeCartDelay;
};
